export default {
  'movementDailyMovementReport.form.filterByDate': 'Filtrar por data de',
  'movementDailyMovementReport.form.filterByDate.entrance': 'Entrada',
  'movementDailyMovementReport.form.filterByDate.authorization': 'Autorização',
  'movementDailyMovementReport.form.filterByDate.shutdown': 'Fechamento',
  'movementDailyMovementReport.form.filterByDate.exit': 'Saída',
  'movementDailyMovementReport.form.filterByDate.delivery': 'Entrega',
  'movementDailyMovementReport.form.filterByDate.info':
    'Quando a opção de filtrar por data de fechamento estiver selecionada juntamente com a opção de venda direta, as vendas diretas serão filtradas por sua data de autorização',

  'movementDailyMovementReport.form.situation': 'Situação',
  'movementDailyMovementReport.form.situation.open': 'Abertos',
  'movementDailyMovementReport.form.situation.authorized': 'Autorizados',
  'movementDailyMovementReport.form.situation.closed': 'Fechados',
  'movementDailyMovementReport.form.situation.canceled': 'Cancelados',

  'movementDailyMovementReport.form.groupReportBy': 'Agrupar relatório por',
  'movementDailyMovementReport.form.groupReportBy.date': 'Data',
  'movementDailyMovementReport.form.groupReportBy.estimatorAndSalesperson':
    'Orçamentista/Vendedor',
  'movementDailyMovementReport.form.groupReportBy.customer': 'Cliente',
  'movementDailyMovementReport.form.groupReportBy.vehicle': 'Veículo',

  'movementDailyMovementReport.form.checkbox.parts': 'Peças',
  'movementDailyMovementReport.form.checkbox.partsProvided': 'Peças fornecidas',
  'movementDailyMovementReport.form.checkbox.tasks': 'Serviços',
  'movementDailyMovementReport.form.checkbox.third': 'Terceiros',
  'movementDailyMovementReport.form.checkbox.directSale': 'Venda Direta',
  'movementDailyMovementReport.form.checkbox.synthetic': 'Sintético?',
  'movementDailyMovementReport.form.checkbox.showMlb':
    'Mostrar Margem de Lucro Bruto',

  'movementDailyMovementReport.form.moreOptions': 'Mais Opções',
  'movementDailyMovementReport.form.moreOptions.estimatorAndSalesperson':
    'Orçamentista/Vendedor',
  'movementDailyMovementReport.form.moreOptions.button.selectCustomers':
    'Selecionar Clientes',
  'movementDailyMovementReport.form.moreOptions.groups': 'Grupo',
  'movementDailyMovementReport.form.moreOptions.ncm': 'NCM',
};
